<template>
    <template
        v-for="(item, index) in items"
        :key="index"
    >
        <li v-if="item.condition === undefined || item.condition">
            <div
                v-if="!item.special"
                class="flex items-center justify-between border-b py-3 px-4"
            >
                <div class="w-1/2 truncate text-sm font-bold capitalize">
                    {{ item.label }}
                </div>
                <div class="flex w-1/2 justify-between">
                    <div
                        class="ml-2 w-full truncate pr-2 text-sm font-medium text-gray-800"
                    >
                        {{ item.value ?? '-' }}
                    </div>
                    <CopyButton
                        v-if="item.copy"
                        :value="item.value"
                        class="justify-self-end"
                    />
                </div>
            </div>

            <div
                v-if="item.special === 'check'"
                class="flex items-center justify-between border-b py-3 px-4"
            >
                <div class="basis-1/2 truncate text-sm font-bold capitalize">
                    {{ item.label }}
                </div>
                <div class="ml-2 basis-1/2 text-sm font-medium text-gray-800">
                    <fa
                        v-if="item.value"
                        icon="fa-circle-check"
                        class="text-success-400 text-xl"
                    />
                    <fa
                        v-else
                        icon="fa-circle-xmark"
                        class="text-danger-400 text-xl"
                    />
                </div>
            </div>

            <div
                v-if="item.special === 'link' && typeof item.value === 'string'"
                class="flex items-center justify-between border-b py-3 px-4"
            >
                <div class="basis-1/2 truncate text-sm font-bold capitalize">
                    {{ item.label }}
                </div>
                <div class="flex basis-1/2 justify-between">
                    <div
                        class="ml-2 max-w-lg truncate text-sm font-medium text-blue-500"
                    >
                        <a
                            :href="item.linkURL || item.value"
                            :target="item.target || '_blank'"
                        >
                            <fa
                                v-if="item.icon"
                                :icon="item.icon"
                                class="mr-2"
                            />{{ item.value }}
                        </a>
                    </div>
                    <CopyButton
                        v-if="item.copy"
                        :value="item.value || item.linkURL"
                    />
                </div>
            </div>

            <div
                v-if="item.special === 'image'"
                class="flex items-center justify-between border-b py-3 px-4"
            >
                <div class="basis-1/2 truncate text-sm font-bold capitalize">
                    {{ item.label }}
                </div>
                <div class="ml-2 basis-1/2">
                    <img
                        v-if="typeof item.value === 'string'"
                        :src="item.value"
                        alt="Platform Logo"
                        class="h-20 w-auto"
                    />
                    <div
                        v-else
                        class="flex h-20 w-20 items-center rounded-full bg-gray-500"
                    >
                        <span class="block w-full text-center text-white"
                            >N/A</span
                        >
                    </div>
                </div>
            </div>
        </li>
    </template>
</template>

<script setup lang="ts">
import CopyButton from '@src/partials/actions/CopyButton.vue'
import { SummaryItem } from '@src/types/Summary'

withDefaults(
    defineProps<{
        items: SummaryItem[]
        notRoundedTop?: boolean
    }>(),
    {
        notRoundedBottom: false,
        notRoundedTop: false,
    }
)
</script>
